import moment from 'moment-timezone'

export const BROWSER_TIMEZONE = moment.tz.guess(true)
